// Shared sort configuration for Anomalies mobile (Missing Data + FTD).
// Each table only supplies its sortable fields + default sort; the actual
// sort function is the generic sortRows() shared across BizDevelopment mobile.

import { sortRows } from "../../../../../../helpers/bizDevelopmentDashboardHelpers";

export interface AnomaliesSortOption {
  label: string;
  value: string;
}

export interface AnomaliesDefaultSort {
  key: string;
  dir: "asc" | "desc";
}

export const sortAnomaliesRows = sortRows;

export const MISSING_DATA_SORT_OPTIONS: AnomaliesSortOption[] = [
  { label: "Brand Name", value: "brand_display_name" },
  { label: "Click Out", value: "clicks" },
  { label: "FTD", value: "ftd" },
  { label: "QFTD", value: "qftd" },
  { label: "CPA Income", value: "cpa_income" },
  { label: "RS Income", value: "revshare_income" },
  { label: "Total Income", value: "totalincome" },
  { label: "Total Income $", value: "total_income_dollar" },
  { label: "Net Rev", value: "net_rev" },
  { label: "EPC", value: "EPC" },
  { label: "ROI", value: "ROI_perc" },
  { label: "PV", value: "PV" },
];

export const DEFAULT_MISSING_DATA_SORT: AnomaliesDefaultSort = {
  key: "brand_display_name",
  dir: "asc",
};

export const CLICKS_WITH_FTD_SORT_OPTIONS: AnomaliesSortOption[] = [
  { label: "Brand Name", value: "brand_name" },
  { label: "Click Out", value: "click_out" },
  { label: "Table", value: "table" },
];

export const DEFAULT_CLICKS_WITH_FTD_SORT: AnomaliesDefaultSort = {
  key: "click_out",
  dir: "desc",
};

export const PROBLEMATIC_FTD_SORT_OPTIONS: AnomaliesSortOption[] = [
  { label: "Brand Name", value: "brand_name" },
  { label: "Players Total FTD", value: "players_total_ftd" },
  { label: "Brand Action Date", value: "brand_action_date" },
];

export const DEFAULT_PROBLEMATIC_FTD_SORT: AnomaliesDefaultSort = {
  key: "players_total_ftd",
  dir: "desc",
};

export const WITHOUT_FTD_SORT_OPTIONS: AnomaliesSortOption[] = [
  { label: "Brand Name", value: "brand_display_name" },
  { label: "Brand Action Date", value: "brand_action_date" },
  { label: "Click Outs", value: "clicks" },
];

export const DEFAULT_WITHOUT_FTD_SORT: AnomaliesDefaultSort = {
  key: "clicks",
  dir: "desc",
};

export const NO_PLAYER_SORT_OPTIONS: AnomaliesSortOption[] = [
  { label: "Brand Name", value: "brand_name" },
  { label: "Brand Action Date", value: "brand_action_date" },
  { label: "Gap in Player's Reporting", value: "GAP" },
  { label: "FTDs in Player Report", value: "Players_FTD" },
  { label: "FTDs in Daily Report", value: "Daily_FTD" },
];

export const DEFAULT_NO_PLAYER_SORT: AnomaliesDefaultSort = {
  key: "GAP",
  dir: "desc",
};

export const INCOME_GAPS_SORT_OPTIONS: AnomaliesSortOption[] = [
  { label: "Brand Name", value: "brand_display_name" },
  { label: "CPA Gap", value: "cpa_gap" },
  { label: "RS Gap", value: "rs_gap" },
  { label: "CPA Income", value: "org_cpa_income" },
  { label: "Calculated CPA Income", value: "cul_cpa_income" },
  { label: "RS Income", value: "org_rs_income" },
  { label: "Calculated RS Income", value: "cul_rs_income" },
  { label: "Average Deal CPA", value: "cpa_deal" },
  { label: "QFTD", value: "qftd" },
  { label: "Average Deal %", value: "rs_deal" },
  { label: "Net Revenue", value: "net_revenue" },
];

export const DEFAULT_INCOME_GAPS_SORT: AnomaliesDefaultSort = {
  key: "brand_display_name",
  dir: "asc",
};

export const DECREASE_DAILY_INCOME_SORT_OPTIONS: AnomaliesSortOption[] = [
  { label: "Brand Name", value: "brand_name" },
  { label: "Brand Action Date", value: "month" },
  { label: "Decreased By", value: "max_minus_current_totalincome" },
  { label: "Max Reported Total Income", value: "max_reported_income" },
  { label: "Current Total Income", value: "current_totalincome" },
];

export const DEFAULT_DECREASE_DAILY_INCOME_SORT: AnomaliesDefaultSort = {
  key: "max_minus_current_totalincome",
  dir: "desc",
};

export const DAILY_EARNINGS_GAPS_SORT_OPTIONS: AnomaliesSortOption[] = [
  { label: "Brand Name", value: "brand_name" },
  { label: "Gap", value: "gap" },
  { label: "Gap Date", value: "brand_action_date" },
  { label: "Previous Total Income", value: "past_totalincome" },
  { label: "Current Total Income", value: "now_totalincome" },
  { label: "Date Captured", value: "captured_date" },
];

export const DEFAULT_DAILY_EARNINGS_GAPS_SORT: AnomaliesDefaultSort = {
  key: "gap",
  dir: "desc",
};

export const MONTHLY_EARNINGS_GAPS_SORT_OPTIONS: AnomaliesSortOption[] = [
  { label: "Brand Name", value: "brand_name" },
  { label: "Gap", value: "gap" },
  { label: "Billing Month", value: "biling_month" },
  { label: "Previous Total Income", value: "end_month_total_income" },
  { label: "Current Total Income", value: "now_totalincome" },
];

export const DEFAULT_MONTHLY_EARNINGS_GAPS_SORT: AnomaliesDefaultSort = {
  key: "gap",
  dir: "desc",
};
